import { addDays, format } from 'date-fns';

export const RESTAURANT_TIME_ZONE = 'America/Detroit';
const detroitFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: RESTAURANT_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
});

// Picker Dates carry restaurant wall digits, not instants. Never serialize them as ISO.
export const pickerToWallTime = (date) => format(date, 'yyyy-MM-dd HH:mm:ss');

export const detroitWallTime = (instant = new Date()) => {
  const parts = {};
  detroitFormatter.formatToParts(instant).forEach(({ type, value }) => { parts[type] = value; });
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`;
};

export const wallTimeToPicker = (wallTime) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?$/.exec(wallTime);
  if (!match) return new Date(NaN);
  return new Date(+match[1], +match[2] - 1, +match[3], +match[4], +match[5], +(match[6] || 0));
};

// VARCHAR responses mix naive Detroit values and genuine offset-bearing instants.
// Never strip Z: it signifies UTC and must be converted with Detroit DST rules.
export const reservationToPicker = (value) => {
  if (typeof value !== 'string') return new Date(NaN);
  const text = value.trim();
  if (/T.*(?:Z|[+-]\d{2}:?\d{2})$/i.test(text)) {
    const instant = new Date(text);
    return Number.isNaN(instant.getTime()) ? instant : wallTimeToPicker(detroitWallTime(instant));
  }
  return wallTimeToPicker(text);
};

export const detroitNowPicker = (now = new Date()) => wallTimeToPicker(detroitWallTime(now));

export const reservationDateRange = (now = new Date()) => {
  const minDate = detroitNowPicker(now);
  minDate.setHours(0, 0, 0, 0);
  return { minDate, maxDate: addDays(minDate, 30) };
};

// Time callbacks may carry a different date; use the selected calendar day.
export const isReservationTimeAllowed = (selectedDay, time, now = new Date()) => {
  if (!selectedDay || !time) return false;
  const candidate = new Date(selectedDay);
  candidate.setHours(time.getHours(), time.getMinutes(), 0, 0);
  const { minDate, maxDate } = reservationDateRange(now);
  const day = format(candidate, 'yyyy-MM-dd');
  return day >= format(minDate, 'yyyy-MM-dd') && day <= format(maxDate, 'yyyy-MM-dd') &&
    candidate.getHours() >= 11 && candidate.getHours() <= 22 &&
    pickerToWallTime(candidate) > detroitWallTime(now);
};
